module.exports = __webpack_public_path__ + "media/images/sort_both-8b117faa9d4dd934d6bbbd9f0cdb2459.png";